import { useState, useEffect, useCallback } from 'react';
import { useLanguage } from '../../../../contexts/LanguageContext';
import {
    useLazyGetRefundDraftListQuery,
    useLazyGetRefundPendingApprovalListQuery,
    useLazyGetRefundApprovedListQuery,
    useLazyGetRefundRejectedListQuery
} from '../../../../api/endpoints/vehicleRefundOrder';

const TAB_KEYS = ['draft', 'pending', 'approved', 'rejected'];

const useRefundOrders = () => {
    const { th, getCurrentLanguageId } = useLanguage();
    const languageId = getCurrentLanguageId();
    const [activeTabIndex, setActiveTabIndex] = useState(0);

    const [fetchDraft, { data: draftList = [], isFetching: draftLoading }] = useLazyGetRefundDraftListQuery();
    const [fetchPending, { data: pendingList = [], isFetching: pendingLoading }] = useLazyGetRefundPendingApprovalListQuery();
    const [fetchApproved, { data: approvedList = [], isFetching: approvedLoading }] = useLazyGetRefundApprovedListQuery();
    const [fetchRejected, { data: rejectedList = [], isFetching: rejectedLoading }] = useLazyGetRefundRejectedListQuery();

    const fetchFns = [fetchDraft, fetchPending, fetchApproved, fetchRejected];
    const dataMap = [draftList, pendingList, approvedList, rejectedList];
    const loadingMap = [draftLoading, pendingLoading, approvedLoading, rejectedLoading];

    useEffect(() => {
        fetchFns[activeTabIndex]({ languageId });
    }, [activeTabIndex, languageId]);

    const refetch = useCallback(() => {
        fetchFns[activeTabIndex]({ languageId });
    }, [activeTabIndex, languageId]);

    const tabConfig = [
        { key: TAB_KEYS[0], label: th('vehicleRefundOrders.tabs.draft'), icon: 'pi pi-file-edit' },
        { key: TAB_KEYS[1], label: th('vehicleRefundOrders.tabs.pendingApproval'), icon: 'pi pi-clock' },
        { key: TAB_KEYS[2], label: th('vehicleRefundOrders.tabs.approved'), icon: 'pi pi-check-circle' },
        { key: TAB_KEYS[3], label: th('vehicleRefundOrders.tabs.rejected'), icon: 'pi pi-times-circle' }
    ];

    return {
        th,
        activeTabIndex,
        setActiveTabIndex,
        activeTabKey: TAB_KEYS[activeTabIndex],
        tabConfig,
        orders: dataMap[activeTabIndex],
        isLoading: loadingMap[activeTabIndex],
        refetch
    };
};

export default useRefundOrders;
